import React from 'react';
import { Link } from 'react-router-dom';
import { Sword, Users, Book, DicesIcon, MessageCircle, Code, Sparkles } from 'lucide-react';
import bgsvg from 'src/assets/hero-background.svg'

import './HomePage.css';

const DiscordLogo = () => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z"/>
  </svg>
);

const FantasyBackground = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 500" className="hero-background">
    {/* Gradients and Patterns */}
    <defs>
      <linearGradient id="skyGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style={{stopColor:"#1a1c3e",stopOpacity:1}} />
        <stop offset="100%" style={{stopColor:"#2a3d66",stopOpacity:1}} />
      </linearGradient>
      
      <radialGradient id="moonGlow" cx="80%" cy="30%" r="20%">
        <stop offset="0%" style={{stopColor:"rgba(255,255,255,0.3)"}} />
        <stop offset="100%" style={{stopColor:"rgba(255,255,255,0)"}} />
      </radialGradient>
      
      <pattern id="magicRunes" x="0" y="0" width="30" height="30" patternUnits="userSpaceOnUse">
        <circle cx="15" cy="15" r="1" fill="#9375db" opacity="0.5" />
        <path d="M10 15 L20 15 M15 10 L15 20" stroke="#9375db" strokeWidth="0.5" opacity="0.3" />
      </pattern>
    </defs>

    {/* Background */}
    <rect width="800" height="500" fill="url(#skyGradient)" />
    
    {/* Moon glow and moon */}
    <circle cx="640" cy="150" r="100" fill="url(#moonGlow)" />
    <circle cx="640" cy="150" r="40" fill="#ffd700" opacity="0.9" />
    
    {/* Distant mountains */}
    <path d="M0 300 L200 200 L400 280 L600 180 L800 280 L800 500 L0 500 Z" fill="#2b1055" opacity="0.7" />
    <path d="M0 340 L300 220 L500 300 L700 200 L800 320 L800 500 L0 500 Z" fill="#3f1c78" opacity="0.8" />
    
    {/* Castle */}
    <g transform="translate(500,200) scale(0.8)">
      <path d="M0 0 L80 0 L80 100 L0 100 Z" fill="#1a1c3e"/>
      <path d="M-20 10 L0 10 L0 120 L-20 120 L-20 10 L-10 0 L0 10" fill="#2b1055"/>
      <path d="M80 10 L100 10 L100 120 L80 120 L80 10 L90 0 L100 10" fill="#2b1055"/>
      <path d="M-20 0 L100 0 L90 -10 L80 0 L70 -10 L60 0 L50 -10 L40 0 L30 -10 L20 0 L10 -10 L0 0 L-10 -10 L-20 0" fill="#2b1055"/>
    </g>

    {/* Wizard */}
    <g transform="translate(480,180)">
      <path d="M0 0 L10 20 L-10 20 Z" fill="#4a237f"/>
      <path d="M0 -10 L15 5 L-5 5 Z" fill="#4a237f"/>
      <circle cx="0" cy="8" r="5" fill="#2b1055"/>
      <path d="M0 0 L20 -10" stroke="#9375db" strokeWidth="2"/>
      <circle cx="20" cy="-10" r="8" fill="url(#magicRunes)"/>
    </g>

    {/* Dragon */}
    <g transform="translate(200,150) scale(0.5)">
      <path d="M0 0 C30 -20 60 -20 90 0 L100 -10 L110 0 L100 10 L90 0 C60 20 30 20 0 0 Z" fill="#2b1055"/>
      <path d="M90 0 L150 -20 L140 0 L150 20" fill="none" stroke="#2b1055" strokeWidth="5"/>
    </g>

    {/* Warriors and Undead Army */}
    <g transform="translate(300,350)">
      <path d="M0 0 L10 30 L-10 30 Z" fill="#3f1c78"/>
      <circle cx="0" cy="0" r="5" fill="#3f1c78"/>
      <path d="M-15 15 L15 15" stroke="#5d2e8c" strokeWidth="3"/>
      
      <g transform="translate(40,0)">
        <path d="M0 0 L8 25 L-8 25 Z" fill="#3f1c78"/>
        <circle cx="0" cy="0" r="4" fill="#3f1c78"/>
        <path d="M-10 10 L10 10" stroke="#5d2e8c" strokeWidth="2"/>
      </g>
    </g>

    <g transform="translate(600,380)">
      <g>
        <path d="M0 0 L5 20 L-5 20 Z" fill="#2b1055"/>
        <circle cx="0" cy="0" r="3" fill="#2b1055"/>
      </g>
      <g transform="translate(20,0)">
        <path d="M0 0 L6 25 L-6 25 Z" fill="#3f1c78"/>
        <circle cx="0" cy="0" r="4" fill="#3f1c78"/>
        <path d="M-8 15 L8 15" stroke="#2b1055" strokeWidth="2"/>
      </g>
      <g transform="translate(40,0) scale(0.8)">
        <path d="M0 0 L5 20 L-5 20 Z" fill="#2b1055"/>
        <circle cx="0" cy="0" r="3" fill="#2b1055"/>
      </g>
    </g>

    {/* Foreground */}
    <path d="M0 380 L200 280 L400 380 L600 280 L800 380 L800 500 L0 500 Z" fill="#5d2e8c"/>

    {/* Magic Elements */}
    <g>
      <path d="M150 150 L160 130 L170 150 L160 160 Z" fill="#9375db" opacity="0.7"/>
      <path d="M300 180 L310 160 L320 180 L310 190 Z" fill="#9375db" opacity="0.7"/>
      <path d="M450 140 L460 120 L470 140 L460 150 Z" fill="#9375db" opacity="0.7"/>
      
      <circle cx="150" cy="150" r="1" fill="white" opacity="0.8"/>
      <circle cx="300" cy="180" r="1" fill="white" opacity="0.8"/>
      <circle cx="450" cy="140" r="1" fill="white" opacity="0.8"/>
      <circle cx="200" cy="160" r="1" fill="white" opacity="0.8"/>
      <circle cx="350" cy="130" r="1" fill="white" opacity="0.8"/>
      <circle cx="500" cy="170" r="1" fill="white" opacity="0.8"/>
    </g>
  </svg>
);

const HomePage = () => {
  return (
    <div className="home-container">
      <header className="hero">
        <FantasyBackground />
        <div className="hero-content">
          <h1 className="hero-title">ChoiceRealms</h1>
          <p className="hero-subtitle">Forge your destiny in a world of endless possibilities!</p>
          <Link to="/games" className="cta-button">Begin Your Adventure</Link>
        </div>
      </header>

      <main>
        <section className="features">
          <div className="feature-card">
            <Sword size={48} />
            <h2>Epic Quests</h2>
            <p>Embark on thrilling adventures across diverse realms.</p>
          </div>
          <div className="feature-card">
            <Users size={48} />
            <h2>Multiplayer</h2>
            <p>Team up with friends or meet new allies on your journey.</p>
          </div>
          <div className="feature-card">
            <Book size={48} />
            <h2>Rich Storytelling</h2>
            <p>Experience dynamic narratives that adapt to your choices.</p>
          </div>
          <div className="feature-card">
            <DicesIcon size={48} />
            <h2>AI Dungeon Master</h2>
            <p>Enjoy responsive and creative game mastering, available 24/7.</p>
          </div>
        </section>

        <section className="news-and-community">
          <div className="latest-news">
            <h2>Coming Soon to the Realms</h2>
            <div className="news-grid">
              <div className="news-item">
                <h3><Code size={20} /> Advanced Character Creation</h3>
                <p>Dive deeper into character customization with our upcoming advanced creation system!</p>
              </div>
              <div className="news-item">
                <h3><Sparkles size={20} /> Dynamic World Events</h3>
                <p>Experience a living, breathing world with our new dynamic event system in development.</p>
              </div>
              <div className="news-item">
                <h3><MessageCircle size={20} /> In-Game Chat System</h3>
                <p>Stay connected with fellow adventurers through our upcoming in-game chat feature.</p>
              </div>
            </div>
          </div>

          <div className="community-section">
            <h2>Join Our Tavern</h2>
            <p>Connect with fellow adventurers in the ChoiceRealms Community!</p>
            <div className="discord-widget">
              <iframe 
                src="https://discord.com/widget?id=1295239833916149902&theme=dark" 
                width="350"
                height="500"
                allowtransparency="true" 
                frameBorder="0" 
                sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
                title="ChoiceRealms Community Discord"
              ></iframe>
            </div>
            <a href="https://discord.gg/UkbXK5vy" target="_blank" rel="noopener noreferrer" className="discord-button">
              <DiscordLogo />
              Join ChoiceRealms Community
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default HomePage;